import { AxiosError, AxiosRequestConfig } from 'axios'
import { user } from 'commons/utils/auth/auth'

const onRequest = (config: AxiosRequestConfig) => {
  if (!config.headers) {
    config.headers = {}
  }

  if (!config.headers?.['Content-Type']) {
    config.headers['Content-Type'] = 'application/json'
  }

  if (!config.headers?.['Authorization']) {
    config.headers['Authorization'] = user.accessToken
  }

  return config
}

const onRequestError = (error: AxiosError) => Promise.reject(error)

export { onRequest, onRequestError }
